import {
  Box,
  Card,
  CardContent,
  Divider,
  Stack,
  Typography
} from '@customink/pigment-react';
import {CardActionArea} from '@customink/pigment-react/lib/components/Card';
import React from 'react';
import ProductCardRating from '../../features/products/components/ProductCard/components/ProductCardRating';
import ProductCardSizesInfo from '../../features/products/components/ProductCard/components/ProductCardSizesInfo';

const ProductDetailsCard = ({
  generalComments,
  imageSrc,
  imageSrcSet,
  linkHref,
  minQty,
  name,
  onClick,
  productId,
  ratingCount,
  ratingScore,
  sizes = []
}) => {
  const hasSizes = sizes.length > 1;

  return (
    <Card sx={{display: 'flex'}}>
      <CardActionArea
        onClick={onClick}
        aria-label={name}
        aria-hidden
        disableRipple
        tabIndex={-1}
        sx={{
          '& .MuiCardActionArea-focusHighlight': {display: 'none'},
          display: 'flex',
          flexDirection: {md: 'column', sm: 'row'}
        }}
        {...(linkHref ? {href: linkHref} : {})}>
        <Box
          sx={{
            objectFit: 'cover',
            overflow: 'hidden',
            paddingTop: {md: '100%', sm: '6.5rem'},
            position: 'relative',
            width: {md: '100%', sm: '6.5rem'}
          }}>
          <Box
            component="img"
            sx={{
              height: '100%',
              left: '50%',
              position: 'absolute',
              top: '50%',
              transform: 'translate(-50%, -50%)'
            }}
            src={imageSrc}
            srcSet={imageSrcSet}
            alt={name}
          />
        </Box>
        <CardContent
          sx={{
            display: 'flex',
            flex: '1',
            flexDirection: 'column',
            gap: '0.3125rem',
            height: '100%',
            justifyContent: {md: 'flex-start', sm: 'center'},
            mt: 0,
            padding: {md: '0.8125rem 1rem', sm: '0.5rem'},
            width: {md: '100%', sm: 'unset'}
          }}>
          <Typography
            sx={{
              color: '#242424',
              fontSize: '0.875rem',
              fontWeight: 700,
              letterSpacing: 0,
              lineHeight: '125%'
            }}>
            {name}
          </Typography>
          {((ratingScore && ratingCount) || hasSizes) && (
            <Stack
              direction="row"
              gap="0.5rem"
              alignItems="center"
              height="1.25rem">
              {ratingScore && ratingCount && (
                <ProductCardRating
                  count={Number(ratingCount.replace(/[()]/g, '').split(' ')[0])}
                  score={Number(ratingScore)}
                  generalComments={generalComments}
                  name={name}
                />
              )}
              {ratingScore && ratingCount && hasSizes && (
                <Divider orientation="vertical" flexItem />
              )}
              {hasSizes && (
                <ProductCardSizesInfo productId={productId} sizes={sizes} />
              )}
            </Stack>
          )}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              lineHeight: '1.25',
              mt: '0.0625rem',
              width: '100%'
            }}>
            <Typography sx={{color: '#4A4A4A', fontSize: '0.8125rem'}}>
              {minQty === 1 ? 'No Minimum' : `Minimum ${minQty}`}
            </Typography>
          </Box>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default ProductDetailsCard;
